module.exports = __webpack_public_path__ + "img/2-8.b9e0aa7e.png";